import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
@Injectable()
export class AssociateService {

  constructor(
    private router: Router,
    private _http: HttpClient,
    private config:Configuration
  ) {}

  // only name base
  public getAllAssociatesFilter(regex, initial?, role?) {
    return this._http.get(`${this.config.ServerApiUrl}/associate/readAllReg?reg=${regex}&&initial=${initial}&&role=${role}`);
}
// mentiosn filters
public getAssociateSearch(skip, limit, query, sort) {
  const queryData = { 'query': query, 'sort': sort };
  console.log('QueryData', queryData);
  return this._http.post(`${this.config.ServerApiUrl}/associate/search/${skip * limit}/${limit}`, queryData);
}

  public getAllAssociates(skip, limit) {
    return this._http.get(`${this.config.ServerApiUrl}/associate/readAll/${skip * limit}/${limit}`);
  }

  public getAssociate(id?: String) {
    if (id != null) {
      return this._http.get(`${this.config.ServerApiUrl}/associate/read?id=${id}`);
    }else {
      return this._http.get(`${this.config.ServerApiUrl}/associate/read?id`);
    }
  }


  public getWelcomeEmailGeneratedUsers(query) {
      return this._http.post(`${this.config.ServerApiUrl}/users/welcomeEmailGeneratedUsers`,{query:query});
  }

  /*public getAssociate (id: String){
    console.log("called get Associate");
    console.log(id);
    const simpleObservable = new Observable((observer) => {
      if(id){
        console.log("get associate with key associate server.ts")
        this._http.get(`${this.config.ServerApiUrl}/associate/read?id=${id}`)
        .subscribe((data) => {
            console.log(data);
            observer.next(data);
        }, (err) => {
            console.log('Error occured while fetching data from api');
            console.log(err);
        });
      }else{
        console.log("get associate without key associate server.ts")
        this._http.get(`${this.config.ServerApiUrl}/associate/read`)
        .subscribe((data) => {
            console.log(data);
            observer.next(data);
        }, (err) => {
            console.log('Error occured while fetching data from api');
            console.log(err);
        });

      }
  });
  return simpleObservable;
  }*/




  
   public assignAccessLevelToAssociate(associateId: string[], accessLevel: string[]): Observable<any> {
     const body = { associateId, accessLevel };
     return this._http.post(`${this.config.ServerApiUrl}/associate/grantAccess`, body);
   }
    
  public createAssociate(associate: any) {
    if (associate != null) {
      return this._http.post(`${this.config.ServerApiUrl}/associate/create`, associate);
    }
  }


  public markAsInactive(id: String) {
    console.log('associate service markInactive called');
    if (id != null) {
      return this._http.post(`${this.config.ServerApiUrl}/associate/delete`, {'idToDelete' : id})

    }
  }
  
  public updateAssociateWorkingGroup(associate: any) {
    return this._http.put(`${this.config.ServerApiUrl}/associate/workingGroupUpdate`, associate);
  }

  public updateAssociate_(associate: any) {
    return this._http.put(`${this.config.ServerApiUrl}/associate/update`, associate);
  }

  public updateAssociatelist(associate: any) {
    return this._http.put(`${this.config.ServerApiUrl}/associate/listUpdate`, associate);
  }

  public updateAssociate(id: String, updateObject) {
    if (id != null) {
      return this._http.put(`${this.config.ServerApiUrl}/associate/update`, {'idToUpdate': id, 'updateObject': updateObject})
    }
  }

  public uploadFile(file: any) {
    if (file) {
      return this._http.post(`${this.config.ServerApiUrl}/associate/uploadFile`, {'file': file})
    }
  }
  
  public saveAssociateDraft(associateDraft: any) {
    if (associateDraft != null) {
      return this._http.post(`${this.config.ServerApiUrl}/associateDraft/save`, associateDraft);
    }
  }
  public readAssociateDraft(associateId,skip,limit) {
      return this._http.post(`${this.config.ServerApiUrl}/associateDraft/read`, {associateId:associateId,skip:skip,limit:limit});
  }

  public updateAssociateDraft(associate) {
    return this._http.post(`${this.config.ServerApiUrl}/associateDraft/update`, associate);
  }
  
  public deleteAssociateDraft(associate) {
    return this._http.post(`${this.config.ServerApiUrl}/associateDraft/delete`, associate);
  }

  public checkDuplicateAssociate(associateObject) {
    const queryData = { 'associate': associateObject };
    // tslint:disable-next-line:max-line-length
    return this._http.post(`${this.config.ServerApiUrl}/associate/checkDuplicateAssociate`, queryData);
}
}
